/*
 * @Date: 2021-11-01 16:15:06
 * @LastEditTime: 2024-01-20 11:52:42
 */
import * as React from 'react'
import HomeSwiper from '../HomSwiper/HomeSwiper'
import HomeMenu from '../HomeMenu/HomeMenu'
// import HomeGuessYouLike from '../HomeGuessYouLike/HomeGuessYouLike'
import HomeModuleController from '../HomeModuleController/HomeModuleController'
import HomeRecommendModule from '../HomeRecommendModule/HomeRecommendModule'
import HomeType from '../../types/HomeType'
import {HttpServer} from '@/services/server'
import globalBus from '@/services/Bus'
import { MemberShipAd } from '@/plugins/MemberShipAd'
import Loading from '@/components/Loading/Loading'
import { HomeTrainingCamp } from '../HomeTrainingCamp/HomeTrainingCamp.tsx'
import { YkCmp } from '../QianKun/yk_cmp'

declare const Session: any

interface HomeState {
    indexData: {
        guess_lectures: HomeType.GuessLecture[] | [],
        banner: HomeType.Banner[] | [],
        modules: HomeType.Module[] | [],
        quick_entries: HomeType.QuickEntry[] | [],
        category: HomeType.Category[] | []
    }
}

export function HomeContent() {

    const [indexData, setIndexData] = React.useState<HomeState>(null)

    React.useEffect(() => {
        const step = 1000 * 5 * 60 // 五分钟后缓存失效重拿接口
        const getRequestDataFromStorage = JSON.parse(window.sessionStorage.getItem('HOMEPAGE/INDEX/REQUEST_DATA'))
        if (getRequestDataFromStorage && ( new Date().getTime() - parseInt(getRequestDataFromStorage.time, 10) < step && window.location.host !== 'dbg.lizhiweike.com' ) ) {
            setIndexData(getRequestDataFromStorage.data)
        } else {
            try {
                HttpServer.addMoniter()
            } catch (e) {
                console.log(e)
            }
            HttpServer.getHomeData().then((res) => {
                if (res.data.code === 0 ) {
                    setIndexData(res.data.data)
                    const setData = {
                        data: res.data.data,
                        time: new Date().getTime()
                    }
                    window.sessionStorage.setItem('HOMEPAGE/INDEX/REQUEST_DATA', JSON.stringify(setData))
                }
            })
        }
        document.title = '发现'
        if (Session.weixinApi) {
            const shareData = {
                title: '十方教育-伴你成长每时每刻',
                link:  window.location.href,
                desc: '专注于大众知识分享的线上教育平台',
                imgUrl: 'https://static-cos.lycheer.net/xupload/20220402_logo_wIFKUeM.png'
            }
            const timeShareData = {
                ...shareData,
                link: `https://share.lizhiweike.com`
            }

            Session.weixinApi.wxShare([shareData, timeShareData])
        }
        globalBus.emit({categoryActiveId: 0})
    }, [])

    if (indexData && indexData !== null) {
        return (
            <div className="HomeContent">
                <div style={{backgroundColor: '#fff'}}>
                    {/* 轮播banner */}
                    <HomeSwiper content={indexData.banner}/>
                    {/* icon */}
                    <HomeMenu content={indexData.quick_entries}/>
                </div>

                {/* 微应用 */}
                <YkCmp />

                {/*  下掉老的训练营代码，由组件化配置 */}
                {/* <HomeTrainingCamp /> */}
                {/* <MemberShipAd/> */}
                {/* feed流 */}
                <HomeModuleController content={indexData.modules}/>
                {/* <HomeGuessYouLike content={indexData.guess_lectures}/> */}
                {/* 滚动加载-更多精选 */}
                <HomeRecommendModule/>
            </div>
        )
    } else {
        return <Loading/>
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeContent/HomeContent.tsx